module.exports = __webpack_public_path__ + "img/logo_blue_eng.0e9988f5.svg";